import { ScrollView, View } from 'react-native'
import React from 'react'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { useSelector } from 'react-redux'
import { NavigationContainer } from '@screens/Common/containers'
import { StyleService, useStyleSheet } from '@style/service.ts'
import { OutlinedIcon } from '@components'
import { Button, Text } from '@components/base'
import { openUrl } from '@utils'
import { uhcDeepLinkSelector } from '@selectors/app.ts'

export const UhcMemberAppAccessBlockedScreen = () => {
  const styles = useStyleSheet(themedStyle)
  const insets = useSafeAreaInsets()
  const uhcDeepLinks = useSelector(uhcDeepLinkSelector)

  const buttonOnPress = () => {
    openUrl(uhcDeepLinks.storeUrl)
  }

  return (
    <NavigationContainer title="Your subscription has ended">
      <ScrollView
        contentContainerStyle={[styles.container, { paddingBottom: insets.bottom + 16 }]}
        bounces={false}
      >
        <View style={styles.content}>
          <OutlinedIcon iconName="warning" style={styles.icon} />
          <Text type="regular" style={styles.text}>
            We'd love to help you keep going on your health journey.
          </Text>
          <Text type="regular" style={styles.text}>
            Visit the UHC Store to choose a one-time or monthly plan and keep using the Nutrisense
            app.
          </Text>
        </View>

        <View>
          <Button
            type="primary"
            size="block"
            onPress={buttonOnPress}
            accessibilityLabel="Visit the UHC Store"
          >
            Visit the UHC Store
          </Button>
        </View>
      </ScrollView>
    </NavigationContainer>
  )
}

const themedStyle = StyleService.create({
  container: {
    paddingTop: 16,
    marginHorizontal: 16,
    flex: 1,
    alignContent: 'space-between',
  },
  content: {
    flex: 1,
    gap: 40,
  },
  text: {
    textAlign: 'center',
  },
  icon: {
    alignSelf: 'center',
  },
})
